module.exports = __webpack_public_path__ + "static/img/1.fa886db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/1.jpg
// module id = eKea
// module chunks = 1